import Vue from "vue"
import App from "@/views/App.vue"
import store from "@/store"
import router from "@/router"
import i18n from "@/lang"

import "@/scss/global.scss"
// import "@/scss2/main.scss"
// import "@/scss3/main.scss"

// @ts-ignore
import mediaqueries from "./plugins/mediaqueries"
Vue.use(mediaqueries)

Vue.config.productionTip = false

new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
}).$mount("#app")
